import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SelectMenu } from '@livable/saas-react-components';
import { TextField, MenuItem, ListItemText, Checkbox, Button, Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UnitOptsModal } from 'src/components/unit/UnitOptInsModal';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
import { useStore } from 'src/stores';
// import { UNIT_TYPES } from 'src/constants/unit';
import useStyles from './styles';
export const UnitForm = observer(_ref => {
  var _store$addNewProperty2, _store$addNewProperty3;
  let unitIndex = _ref.unitIndex,
    unitTypeProp = _ref.unitTypeProp,
    utilityType = _ref.utilityType,
    isLoaded = _ref.isLoaded,
    isSubmited = _ref.isSubmited,
    requiredSquareFootage = _ref.requiredSquareFootage,
    _startRerender = _ref._startRerender;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    amenitiesTooltipOpen = _useState2[0],
    setAmenitiesTooltipOpen = _useState2[1];
  const requiredInput = (value, id) => {
    if (!value.trim().length || value === 'none') {
      store.addNewProperty.unitSetup.validateValue(unitIndex, id, false);
    } else {
      store.addNewProperty.unitSetup.validateValue(unitIndex, id, true);
    }
  };
  const requiredInputMinValue = (value, id, minValue) => {
    if (value < minValue) {
      store.addNewProperty.unitSetup.validateValue(unitIndex, id, false);
    } else {
      store.addNewProperty.unitSetup.validateValue(unitIndex, id, true);
    }
  };
  const _useState3 = useState(store.addNewProperty.unitSetup.units[unitIndex].amenities.length ? store.addNewProperty.unitSetup.units[unitIndex].amenities.map(item => item.inUnitAmenityOptionId) : []),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAmenities = _useState4[0],
    setSelectedAmenities = _useState4[1];
  const handleAmenitiesChange = (event, child) => {
    if (child.props.value) {
      let triggerId = null;
      const globalId = store.addNewProperty.unitSetup.amenities.find(item => item.optionId === child.props.value).id;
      const globalGroup = store.addNewProperty.unitSetup.amenities.filter(item => item.id === globalId);
      const prevValue = event.target.value.filter(item => item !== child.props.value);
      globalGroup.map(item => {
        if (prevValue.includes(item.optionId)) {
          triggerId = item.optionId;
        }
      });
      const newValue = event.target.value.filter(item => {
        return item !== triggerId;
      });
      setSelectedAmenities(newValue);
      store.addNewProperty.unitSetup.changeAmenities(unitIndex, newValue);
    }
  };
  const copyAmenitiesToAll = () => {
    store.addNewProperty.unitSetup.units.map((_i, k) => {
      if (k === 0) return;
      store.addNewProperty.unitSetup.changeAmenities(k, selectedAmenities);
    });
    _startRerender();
  };

  // const [unitType, setUnitType] = useState(
  //   store.addNewProperty.unitSetup.units[unitIndex].type.length > 0 &&
  //     store.addNewProperty.unitSetup.units[unitIndex].type !== 'None'
  //     ? store.addNewProperty.unitSetup.units[unitIndex].type
  //     : 'None'
  // );

  // const handleUnitTypeChange = (event, child) => {
  //   if (child.props.value) {
  //     setUnitType(event.target.value);
  //     store.addNewProperty.unitSetup.changeType(
  //       unitIndex,
  //       event.target.value
  //     );
  //   }
  // };

  const optInsTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    className: "".concat(classes.smButton, " ").concat(store.addNewProperty.unitSetup.units[unitIndex].disabledOptOutUtilityIds.length > 0 ? 'warningButton' : ''),
    'custom-attribute': '145-unit-form'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "settings"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText ".concat(classes.hideTablet)
  }, t('add_new_property_flow.billing_setup')));
  const getAmenitiesNames = data => {
    const amenitiesNames = [];
    data.map(item => {
      var _store$addNewProperty;
      const idx = store.addNewProperty.unitSetup.amenities.findIndex(amenity => amenity.optionId === item);
      amenitiesNames.push("".concat((_store$addNewProperty = store.addNewProperty.unitSetup.amenities[idx]) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.name));
    });
    return amenitiesNames.join(', ');
  };
  useEffect(() => {
    setSelectedAmenities(store.addNewProperty.unitSetup.units[unitIndex].amenities.length ? store.addNewProperty.unitSetup.units[unitIndex].amenities.map(item => item.inUnitAmenityOptionId) : []);

    // setUnitType(
    //   store.addNewProperty.unitSetup.units[unitIndex].type.length > 0 &&
    //     store.addNewProperty.unitSetup.units[unitIndex].type !== 'None'
    //     ? store.addNewProperty.unitSetup.units[unitIndex].type
    //     : 'None'
    // );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitTypeProp]);
  useEffect(() => {
    setSelectedAmenities(store.addNewProperty.unitSetup.units[unitIndex].amenities.length ? store.addNewProperty.unitSetup.units[unitIndex].amenities.map(item => item.inUnitAmenityOptionId) : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.unitInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldXs
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.unit_number'),
    variant: "outlined",
    fullWidth: true,
    type: "text",
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    value: store.addNewProperty.unitSetup.units[unitIndex].name,
    onChange: e => {
      store.addNewProperty.unitSetup.changeName(unitIndex, e.target.value);
      requiredInput(e.target.value, 'name');
    },
    error: isSubmited && !store.addNewProperty.unitSetup.unitsValidation[unitIndex].name
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.fieldXs
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.sq_ft'),
    variant: "outlined",
    type: "text",
    fullWidth: true,
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    value: store.addNewProperty.unitSetup.units[unitIndex].square,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      store.addNewProperty.unitSetup.changeSquare(unitIndex, e.target.value);
      requiredInput(e.target.value, 'square');
      if (requiredSquareFootage) requiredInputMinValue(e.target.value, 'square', 1);
    },
    error: isSubmited && !store.addNewProperty.unitSetup.unitsValidation[unitIndex].square
  })), ((_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.selectedUtilities) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.findIndex(i => i.allocationMethod === ALLOCATION_METHOD.ByPercentageShare)) !== -1 && /*#__PURE__*/React.createElement("div", {
    className: classes.fieldXs
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Percentage, %'),
    variant: "outlined",
    type: "text",
    fullWidth: true,
    value: ((_store$addNewProperty3 = store.addNewProperty.unitSetup.units[unitIndex].unitUtilities.find(i => i.utilityId === utilityType)) === null || _store$addNewProperty3 === void 0 ? void 0 : _store$addNewProperty3.allocationPercentage) || '',
    onChange: e => {
      const rawValue = e.target.value.replace(',', '.');
      if (rawValue === '') {
        store.addNewProperty.unitSetup.changeUnitUtilities(unitIndex, utilityType, '');
        return;
      }
      if (!/^\d{0,3}(\.\d{0,2})?$/.test(rawValue)) return;
      const numeric = Number(rawValue);
      if (numeric > 100) return;
      store.addNewProperty.unitSetup.changeUnitUtilities(unitIndex, utilityType, rawValue);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.fieldMd, " ").concat(classes.fullWidth, " ").concat(classes.flex, " ").concat(store.company.companyFeatureStore.isAppfolio ? classes.orderLast : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.fullWidth, " ").concat(store.company.companyFeatureStore.isAppfolio ? classes.zeroRightRadius : '')
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: t('add_new_property_flow.amenities_field_hint'),
    placement: "top",
    open: amenitiesTooltipOpen
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setAmenitiesTooltipOpen(true),
    onMouseLeave: () => setAmenitiesTooltipOpen(false),
    onClick: () => setAmenitiesTooltipOpen(false)
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "amenities-selector",
    displayEmpty: true,
    value: selectedAmenities,
    onChange: handleAmenitiesChange,
    multiple: true,
    disabled: store.addNewProperty.unitSetup.amenities.length === 0,
    renderValue: selected => {
      if (selected.length === 0) {
        return /*#__PURE__*/React.createElement("span", null, t('general.none'));
      }
      return getAmenitiesNames(selected);
    },
    label: t('add_new_property_flow.amenities'),
    labelId: "amenities-label"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true,
    value: ""
  }, t('general.none')), store.addNewProperty.unitSetup.amenities.map(amenity => /*#__PURE__*/React.createElement(MenuItem, {
    key: amenity.optionId,
    value: amenity.optionId,
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedAmenities.indexOf(amenity.optionId) > -1
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "".concat(amenity.name)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.copyToAll, " ").concat(unitIndex !== 0 ? 'hidden' : '')
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => copyAmenitiesToAll(),
    'custom-attribute': '146-unit-form'
  }, "Copy to all"))), store.addNewProperty.utilitiesSetupV2.selectedUtilities.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(UnitOptsModal, {
    trigger: optInsTrigger,
    unitIndex: unitIndex
  })));
});